import React, {Component} from "react";
import DatePicker from "react-datepicker"
import * as moment from "moment";
import _ from "lodash";
import TextEditor from "../../../elements/forms/wysiwyg_field";

class CalendarForm extends Component {
	render() {
		return <div className="calendar-form">
			<form id="calendarForm">
				<div className="field is-grouped">
					<div className="control is-expanded">
						<label htmlFor="name" className="label">Nombre</label>
						<input type="text" id="name" ref="name" className="input" placeholder="Nombre del evento" />
					</div>
					<div className="control">
						<label htmlFor="start_date" className="label">Fecha</label>
						<DatePicker onChange={this.changeDate} className="input" selected={this.state.start_date} placeholderText={moment().format('YYYY-MM-DD')} dateFormat="YYYY-MM-DD" />
					</div>
				</div>

				<div className="field is-grouped">
					<div className="control is-expanded">
						<label htmlFor="start_time" className="label">Inicia</label>
						<DatePicker onChange={this.changeStartTime}
						            className="input"
						            selected={this.state.start_time}
						            placeholderText={moment().format('hh:mm')}
						            timeIntervals={15}
						            dateFormat="LT"
						            timeCaption="Hora"
						            showTimeSelect
						            showTimeSelectOnly
						/>
					</div>
					<div className="control is-expanded">
						<label htmlFor="end_time" className="label">Termina</label>
						<DatePicker onChange={this.changeEndTime}
						            className="input"
						            selected={this.state.end_time}
						            placeholderText={moment().format('hh:mm')}
						            timeIntervals={15}
						            dateFormat="LT"
						            timeCaption="Hora"
						            showTimeSelect
						            showTimeSelectOnly
						/>
					</div>
					<div className="control">
						<label htmlFor="place" className="label">Ubicación</label>
						<div className="select">
							<select ref="place" id="place">
								<option value={0} defaultValue={0}>--- Ubicación ---</option>
								{_.map(this.props.places, (place, p) => {
									return <option value={place.id} key={`place-option-${p}`}>{place.name}</option>
								})}
							</select>
						</div>
					</div>
				</div>

				<div className="field">
					<div className="control">
						<label htmlFor="description" className="label">Descripción</label>
						<TextEditor id="description" ref="description" placeholder="Descripción de la actividad" value={this.state.description} onChange={(value) => this.setDescription(value)} />
					</div>
				</div>

				<div className="field is-grouped is-grouped-right">
					<button type="button" onClick={this.addEntry} className="button is-medium is-cdm-blue">Guardar</button>
				</div>
			</form>
		</div>
	}

	constructor() {
		super();
		this.state = {
			start_date: undefined,
			start_time: undefined,
			end_time: undefined,
			description: ''
		}
		this.changeDate = this.changeDate.bind(this);
		this.changeStartTime = this.changeStartTime.bind(this);
		this.changeEndTime = this.changeEndTime.bind(this);
		this.setDescription = this.setDescription.bind(this);
		this.addEntry = this.addEntry.bind(this);
	}

	changeDate(date) {
		return this.setState({
			start_date: moment(date)
		});
	}

	changeStartTime(time) {
		return this.setState({
			start_time: moment(time)
		});
	}

	changeEndTime(time) {
		return this.setState({
			end_time: moment(time)
		});
	}

	setDescription(desc) {
		return this.setState({
			description: desc
		});
	}

	addEntry() {
		this.props.addEntry({
			id: this.props.nextId,
			name: this.refs.name.value,
			place: { id: _.toInteger(this.refs.place.value)},
			start_date: moment(this.state.start_date).format('YYYY-MM-DD'),
			start_time: moment(this.state.start_time).format('HH:MM'),
			end_time: moment(this.state.end_time).format('HH:MM'),
			description: this.state.description
		});
		_.map(this.refs, el => {
			switch (el.type) {
				case 'checkbox':
					return el.checked = false;
				case 'select-one':
					return el.value = 0;
				default:
					return el.value = '';
			}
		});
		return this.setState({
			start_date: undefined,
			start_time: undefined,
			end_time: undefined,
			description: ''
		});
	}
}

export default CalendarForm;


// WEBPACK FOOTER //
// ./src/cdm-frontend/elements/calendar/calendar-form.jsx